import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: false,
  faqData: []
};

const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    getFaqStart: (state, action) => {
      state.loading = true;
    },
    getFaqSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.faqData = action.payload;
    },
    getFaqFailure: (state, action) => {
      state.loading = false;
      state.error = true;
    }
  }
});

export const { getFaqStart, getFaqSuccess, getFaqFailure } = faqSlice.actions;

export default faqSlice.reducer;
